import React, { useState, useEffect } from "react";
import "./Special_State.css";
import {
  Electricitys,
  RooftopSolars,
} from "../../../utils/apis/subsidy-policy/SubsidyPolicy";

const Special_State = () => {
  const [electricity, setElectricity] = useState([]);

  const getElectricity = async () => {
    const res = await Electricitys();

    console.log("Electricity data", res);
    

    if (res?.success) {
      setElectricity(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getElectricity();
  }, []);

  const [rooftopsolar, setRooftopSolar] = useState([]);

  const getRooftopSolar = async () => {
    const res = await RooftopSolars();

    console.log("rooftop data", res);

    if (res?.success) {
      setRooftopSolar(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getRooftopSolar();
  }, []);

  return (
    <section className="Special_State">
      <div className="container">
        <div className="Special_State_div">
          <div className="row justify-content-center">
            <div className="col-lg-5 col-md-5">
              <div className="Special_State_left_div">
                <p className="Special_State_title">
                  For special states, an additional 10% Subsidy will be
                  applicable per kW
                </p>
                <h5 className="Special_State_subtitle">
                  Suitable Rooftop Solar Plant Capacity for households
                </h5>
              </div>
            </div>

            <div className="col-lg-7 col-md-7">
              <div className="Special_State_right_div_holder">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-6">
                    
                      <div className="Special_State_right_div">
                        <div className="Special_State_right_header">
                          <h5 className="Special_State_right_title">
                            Average Monthly Electricity Consumption (units)
                          </h5>
                        </div>
                        {electricity.map((item) => (
                        <p className="list">{item.name}</p>
                        ))}
                        {/* <p className="list">150-300</p>
                          <p className="list">300</p> */}
                      </div>
                   
                  </div>

                  <div className="col-lg-6 col-md-6 col-6">
                    
                      <div className="Special_State_right_div">
                        <div className="Special_State_right_header">
                          <h5 className="Special_State_right_title">
                            Suitable Rooftop Solar Plant Capacity
                          </h5>
                        </div>
                        {rooftopsolar.map((val) => (
                        <p className="list">{val.name}</p>
                        ))}
                        {/* <p className="list">2-3 kw</p>
                        <p className="list">Above 3 kw</p> */}
                      </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Special_State;
